import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, take, tap } from 'rxjs';
import { BookShipmentStepper } from 'src/app/components/book-shipment-stepper/book-shipment-stepper';
import { ITitlePage } from 'src/app/shared/misc/title-page';
import { Shipment } from 'src/app/shared/models/shipment';
import { ShipmentBooking } from 'src/app/shared/models/shipment-booking';
import { ShipmentsApiService } from 'src/app/shared/services/shipments-api.service';
import { SnackbarWithNavService } from 'src/app/shared/services/snackbar-with-nav.service';

@Component({
  selector: 'app-couriers',
  imports: [
    BookShipmentStepper,
  ],
  templateUrl: './book-shipment.component.html',
  styleUrl: './book-shipment.component.scss'
})
export class BookShipmentComponent implements ITitlePage {
  readonly title = signal<string>("Boka retur");
  private readonly snackBarService = inject(SnackbarWithNavService);
  private readonly router = inject(Router);
  private readonly shipmentsApiService = inject(ShipmentsApiService);

  onBookShipment(shipmentBooking: ShipmentBooking): void {
    this.shipmentsApiService
      .bookShipment(shipmentBooking)
      .pipe(
        take(1),
        tap(shipment => {
          this.onNavigateToShipment(shipment);
        }),
        catchError(error => {
          this.snackBarService.show("Fel vid bokning!", '/home', 'error-snackbar');
          console.error(error);
          return EMPTY;
        })
      ).subscribe();
  }

  onNavigateToShipment(shipment: Shipment): void {
    this.router.navigate(['/shipments', shipment.Courier, shipment.ShipmentId]);
  }

  onCancel(): void {
    this.router.navigate(['/home']);
  }
}
